<template>
    <div>Настройки чата.</div>
</template>

<script>
    export default {
        name: "Profile-user"
    }
</script>

<style scoped>

</style>
